<template>
  <div id="app">
    <!--<keep-alive >-->
      <router-view />
    <!--</keep-alive>-->
  </div>
</template>
<script>
export default {
  name: 'App'
}
</script>
<style lang="scss">
  .van-nav-bar .van-icon{
    color: rgba(102, 102, 102, 1)!important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue